import { render, staticRenderFns } from "./ItemCardPrice.vue?vue&type=template&id=fb01507a&"
import script from "./ItemCardPrice.vue?vue&type=script&lang=js&"
export * from "./ItemCardPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports